import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import SBAFooterDesktop from "./SBAFooterDesktop";
import SBAFooterMobile from "./SBAFooterMobile";

/**
 * Component to display footer in SBA pages
 */
const SBAFooter = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="sba-footer-component"
      className="mb-4 bg-gray-850 py-9 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <SBAFooterDesktop /> : <SBAFooterMobile />}
      </Container>
    </footer>
  );
};

export default SBAFooter;
